import React from 'react'
import Relazsizes from 'relazsizes'

import config from 'config'
import Container from 'components/atoms/Container'

const { assets_url: assetsUrl } = config

const AptitudeBanner = () => (
  <div className="aptitude-banner">
    <Container next mobileFull>
      <a
        href="https://campus.quipper.com/scholarships/quipper-scholarship-award-2021?utm_source=Internal&utm_medium=referral&utm_campaign=QSA_2021&utm_term=jan2021&utm_content=qsa_registernow_aptitudetestbannerweb"
        target="_blank"
        rel="noopener"
      >
        <Relazsizes
          el="picture"
          dataSrc={`${assetsUrl}/assets/img/qsa_banner/qsa_banner-mobile.png`}
          dataSrcset={[
            {
              media: '(min-width: 768px)',
              srcset: `${assetsUrl}/assets/img/qsa_banner/qsa_banner-desktop.png`,
              alt: 'QSA - Register Now',
            },
          ]}
          alt="QSA - Register Now"
        />
      </a>
    </Container>
    <style jsx>
      {`
        .aptitude-banner {
          background: linear-gradient(180deg, #FFF 50%, #f5fcff 50%);
          :global(img) {
            width: 100%;
          }
        }
      `}
    </style>
  </div>
)

export default AptitudeBanner
